import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';

const ButtonCommon = ({
                        variant = 'submit',
                        type = 'button',
                        label,
                        icon,
                        onClick,
                        disabled,
                        customContainerStyles,
                        customLabelStyles,
                        customIconStyles,
                      }) => {

  switch (variant) {
    case 'icon':
      return (
        <button
          type={type}
          className={classnames(styles.buttonIconContainer, customContainerStyles)}
          onClick={onClick}
          disabled={disabled}
        >
          <img
            src={icon}
            alt="icon"
            className={customIconStyles}
          />
        </button>
      )
    case 'cancel':
      return (
        <button
          type={type}
          className={classnames(styles.buttonCancelContainer, customContainerStyles)}
          onClick={onClick}
          disabled={disabled}
        >
          {icon && (
            <img
              src={icon}
              alt="icon"
              className={customIconStyles}
            />
          )}
          {label && (
            <div
              className={classnames(styles.cancelLabel, customLabelStyles)}
            >
              {label}
            </div>
          )}
        </button>
      )
    case 'submit':
    default:
      return (
        <button
          type={type}
          className={classnames(styles.buttonContainer, customContainerStyles)}
          onClick={onClick}
          disabled={disabled}
        >
          {icon && (
            <img
              src={icon}
              alt="icon"
              className={customIconStyles}
            />
          )}
          {label && (
            <div
              className={classnames(styles.label, customLabelStyles)}
            >
              {label}
            </div>
          )}
        </button>
      );
  }
};

export default ButtonCommon;